import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getInvitationReceipt = async (id) => {
    const response = await axios.get(routes.getInvitationReceipt(id), AXIOS_DEFAULT_CONFIG);
    return response;
};
export default getInvitationReceipt;
